import { render, staticRenderFns } from "./PanelBenefits.vue?vue&type=template&id=cab13192&scoped=true&"
import script from "./PanelBenefits.vue?vue&type=script&lang=js&"
export * from "./PanelBenefits.vue?vue&type=script&lang=js&"
import style0 from "./PanelBenefits.vue?vue&type=style&index=0&id=cab13192&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab13192",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
